import * as React from 'react';

import {
  Colors,

  Text,
} from '@bluecurrent/web-component-lib';

const height = 45;

function Divider({
  isVisible,
}) {
  return isVisible && (
    <div
      style={{
        height: height / 2.5,
        width: 2,
        backgroundColor: Colors.MEDIUM_WHITE,
      }}
    />
  );
}

function Item({
  text,
  isActive,
  onClick,
}) {
  return (
    <button
      type="button"
      style={{
        backgroundColor: isActive ? '#33ADE2' : 'transparent',
        borderRadius: 7,
        height: height - 10,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        paddingLeft: 10,
        paddingRight: 10,
        minWidth: 100,
        border: 'none',
        fontSize: '1em',
        gap: 5,
        cursor: isActive ? 'default' : 'pointer',
      }}
      onClick={() => onClick()}
    >
      <Text
        fontSize="1em"
        color={isActive ? Colors.WHITE : Colors.GREY}
        fontWeight={isActive ? 500 : 300}
      >
        {text}
      </Text>
    </button>
  );
}

export default function SegmentedControls({
  items,
}) {
  return (
    <div
      style={{
        width: 'auto',
        minWidth: 200,
        height,
        backgroundColor: Colors.WHITE,
        border: `solid 2px ${Colors.MEDIUM_WHITE}`,
        borderRadius: 10,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingLeft: 3,
        paddingRight: 3,
        gap: 5,
      }}
    >
      {
        items?.map((item, index) => {
          const isNextActive = index >= 0 && (index + 1) !== items.length
            ? items[index + 1].isActive
            : false;

          return (
            <React.Fragment
              key={item.id}
            >
              <Item
                text={item.text}
                icon={item?.icon}
                isActive={item.isActive}
                onClick={item.onClick}
              />
              <Divider
                isVisible={
                  !isNextActive
                  && !item.isActive
                  && items.length !== (index + 1)
                }
              />
            </React.Fragment>
          );
        })
      }
    </div>
  );
}
